import { Injectable } from '@angular/core';
import {GenericResponse } from '../business-entities/generic-response'
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';
import { KeyDropLocationViewModel } from '../business-entities/dealer-keydrop-location-view-model';

@Injectable({
    providedIn: 'root'
})

export class KeyDropLocationDataService
{
    constructor(private dataProvider: DataService) {
    }

    async getKeyDropLocation(dealerId: string): Promise<GenericResponse<Array<KeyDropLocationViewModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<KeyDropLocationViewModel>>>(Urls.GetKeyDopLocation, dealerId).toPromise();
    }

    addKeyDropLocation(keyDropLocationModel: KeyDropLocationViewModel): Promise<GenericResponse<KeyDropLocationViewModel>> {
        return this.dataProvider.Post<GenericResponse<KeyDropLocationViewModel>>(Urls.AddKeyDopLocation, keyDropLocationModel).toPromise();
    }
    
    async getKeyDropLocationById(Id: number): Promise<GenericResponse<KeyDropLocationViewModel>> {
        return this.dataProvider.Get<GenericResponse<KeyDropLocationViewModel>>
        (Urls.GetKeyDopLocationById, Id).toPromise();
    }

    updateKeyDropLocation(keyDropLocationModel : KeyDropLocationViewModel) : Promise<GenericResponse<KeyDropLocationViewModel>> {
            return this.dataProvider.Put<GenericResponse<KeyDropLocationViewModel>>(Urls.UpdateKeyDopLocation, keyDropLocationModel).toPromise();
    }

    deleteKeyDropLocation(Id: number):Promise<GenericResponse<boolean>> {
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteKeyDopLocation, Id).toPromise();
    }

    async getLocationList(): Promise<GenericResponse<Array<SelectListItemViewModel>>> {
        return this.dataProvider.GetAll<GenericResponse<Array<SelectListItemViewModel>>>(Urls.GetLocationList).toPromise();
    }
}